import { Injectable } from '@angular/core';
import { IStoreBase } from '@boxx/core';
import {
  EventModel,
  IEventsStateError,
  IEventsStateSuccess,
} from '@boxx/events-core';
import { Store } from '@ngrx/store';
import * as fromActions from './events.actions';
import * as fromReducer from './events.reducer';
import * as fromSelector from './events.selectors';

@Injectable()
export class EventsStore
  implements IStoreBase<EventModel[], IEventsStateSuccess, IEventsStateError>
{
  constructor(public store: Store<fromReducer.EventsState>) {}

  get loading$() {
    return this.store.select(fromSelector.getIsLoading);
  }

  get error$() {
    return this.store.select(fromSelector.getError);
  }

  get success$() {
    return this.store.select(fromSelector.getSuccess);
  }

  get data$() {
    return this.store.select(fromSelector.getEvents);
  }

  get fetched$() {
    return this.store.select(fromSelector.getHasBeenFetched);
  }

  eventById$(id: number) {
    this.store.dispatch(fromActions.selectEventAction({ eventId: id }));
    return this.store.select(fromSelector.getEventById);
  }

  selectedEvent$() {
    return this.store.select(fromSelector.getSelectedEventId);
  }

  fetch() {
    return this.store.dispatch(fromActions.getEventsBeginAction());
  }

  createEvent(payload: EventModel) {
    return this.store.dispatch(fromActions.createEventBeginAction({ payload }));
  }

  updateEvent(payload: EventModel) {
    return this.store.dispatch(fromActions.updateEventBeginAction({ payload }));
  }

  deleteEvent(eventId: number) {
    return this.store.dispatch(fromActions.deleteEventBeginAction({ eventId }));
  }
}
